import React, { useState, useEffect } from "react";
import { Form, Input, Select, Row, Col, message, Button } from "antd";
import { platformApi } from "../../../../api";
import { useHistory } from "react-router-dom";
import DraggableResizableModal from "../../../DraggableResizableModal";
import { formatValue } from "../../../../utils";

const { Item } = Form;
const { Option } = Select;

const Index = (props) => {
  const { form } = props;
  const { getFieldDecorator, resetFields, setFieldsValue, getFieldValue } = form;
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const getFormattedName = () => {
    const nameValue = getFieldValue('name');
    return formatValue({ target: { value: nameValue || '' } }, "allCaps");
  };

  useEffect(() => {
    if (props.open) {
      resetFields();
      if (props.phone) {
        form.setFieldsValue({ phone: props.phone });
      }
      if (props.customerName) {
        const formattedName = formatValue(
          { target: { value: props.customerName } }, 
          "allCaps"
        );
        form.setFieldsValue({ name: formattedName });
      }
    }
  }, [props.open, props.phone, props.customerName]);

  const handleSubmit = () => {
    if(props.customerName){
      form.validateFields(async (validationError, values) => {
        if (!validationError) {
          setLoading(true);
          const formattedName = getFormattedName();
          const { phone, customerType } = values;
          
          if (customerType?.toLowerCase() === "sales customer") {
            history.push("/autoadmin/quotations", {
              phone: phone,
              name: formattedName,
              lead: "call enquiry",
            });
          } else {
            props.close();
            resetFields();
          }
        }})

      return;
    }

    form.validateFields(async (validationError, values) => {
      if (!validationError) {
        setLoading(true);
        const formattedName = getFormattedName();
        const { phone, customerType } = values;

        let customerId = props.cusId || "";
        if (!props.cusId) {
          try {
            const idRes = await platformApi.post("/api/idGenerate/customer");
            if (idRes.data.code === 200) {
              customerId = idRes.data.response.data;
              props.setCusId(customerId);
            } else {
              message.error("Couldn't fetch customer ID");
              setLoading(false);
              return;
            }
          } catch (err) {
            message.error("Error generating customer ID", err);
            console.log("error", err);

            setLoading(false);
            return;
          }
        }

        const customerData = {
          customerId,
          name: formattedName,
          customerType:"Non Customer",
          contacts: [
            {
              WhatsApp: false,
              DND: false,
              id: "",
              valid: true,
              type: "Primary",
              phone: phone,
            },
          ],
        };

        try {
          const res = await platformApi.post("/api/customer", customerData);

          if (res.data.code === 200) {
            message.success("Customer added successfully!");
            props.emitData(res.data.response.data);
            if (customerType.toLowerCase() === "sales customer") {
              history.push("/autoadmin/quotations", {
                phone: phone,
                name: formattedName,
                lead: "call enquiry",
              });
            } else {
              props.close();
              resetFields();
            }
          } else {
            message.error("Failed to add customer");
          }
        } catch (error) {
          console.error("Error adding customer:", error);
          message.error("Failed to add customer");
        } finally {
          setLoading(false);
        }
      }
    });
  };

  return (
    <DraggableResizableModal
      visible={props.open}
      onClose={() => {
        props.close();
        resetFields();
      }}
      title="Add New Customer"
      defaultWidth={250}
      defaultHeight={500}
    >
      <Form layout="vertical">
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Item label="Customer Name">
              {getFieldDecorator("name", {
                rules: [
                  { required: true, message: "Please enter customer name" },
                ],
              })(
                <Input 
                  placeholder="Enter name" 
                  onKeyUp={(e) => {
                    const formattedValue = formatValue(e, "allCaps");
                    form.setFieldsValue({
                      name: formattedValue,
                    });
                  }}
                  onBlur={(e) => {
                    const formattedValue = formatValue(e, "allCaps");
                    setFieldsValue({ name: formattedValue });
                  }}
                />
              )}
            </Item>
          </Col>

          <Col span={24}>
            <Item label="Phone Number">
              {getFieldDecorator("phone", {
                rules: [
                  { required: true, message: "Please enter phone number" },
                ],
              })(<Input placeholder="Phone number" />)}
            </Item>
          </Col>

          <Col span={24}>
            <Item label="Customer Type">
              {getFieldDecorator("customerType", {
                rules: [
                  { required: true, message: "Please select customer type" },
                ],
                initialValue: "Sales Customer",
              })(
                <Select placeholder="Select type">
                  <Option value="Sales Customer">Sales Customer</Option>
                  <Option value="Service Customer">Service Customer</Option>
                  <Option value="Spare Customer">Spare Customer</Option>
                </Select>
              )}
            </Item>
          </Col>
        </Row>
        <div style={{ textAlign: 'right', marginTop: 16 }}>
          <Button 
            onClick={() => {
              props.close();
              resetFields();
            }}
            style={{ marginRight: 8 }}
          >
            Cancel
          </Button>
          <Button 
            type="primary" 
            onClick={handleSubmit}
            loading={loading}
          >
            Submit
          </Button>
        </div>
      </Form>
    </DraggableResizableModal>
  );
};

export default Form.create()(Index);
